import FormError from '../../../errors/FormError';
import { FormResponseErrorType } from '../../../enums/FormResponseErrorType';

// remember: false is a valid value
function valueIsValid(value) {
  return value !== null && value !== undefined && value !== '';
}

export default function formDataExtractor(parameters, method) {
  const allParams = Object.values(parameters);

  // do not send empty formData object, when there are no parameters, see encoding bug SON-17537
  if (allParams.length === 0) {
    return null;
  }

  // switching permanently to FormData from (partly) URLSearchParams (they have same api -> .append())
  //  see encoding bug SON-17537
  const data = method === 'GET' ? new URLSearchParams() : new FormData();

  try {
    allParams
      .map(param => param.getPayloadValue()) // get every top level payload of each registered param (not children)
      .flat(5) // flatten until no arrays in arrays
      .filter(item => valueIsValid(item?.value)) // filter only valid
      .forEach(item => data.append(item.name, item.value)); // append all params.
  } catch {
    throw new FormError(FormResponseErrorType.PAYLOAD_ERROR);
  }
  return data;
}
